<template>
  <transition name="slide" appear @enter="enter">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'CardTransition',
  methods: {
    enter(element) {
      const { requestAnimationFrame } = window

      const percentTexts = element.querySelectorAll('.performance-card__meter-percent-text')
      const footerTexts = element.querySelectorAll('.performance-card__meter-footer-text')
      const meters = element.querySelectorAll('.performance-card__meter')
      const innerMeters = element.querySelectorAll('.performance-card__meter-inner')

      const widths = Array.from(percentTexts, ele =>  ele.textContent.trim())

      widths.forEach((width, index) => {
        const flex = Number(width.replace('%', ''))
        const currentPercent = percentTexts[index]
        const currentFooter = footerTexts[index]
        const currentMeter = meters[index]

        if (index === 0) {
          currentFooter.style.flex = currentPercent.style.flex = flex
        } else {
          currentFooter.style.flex = currentPercent.style.flex = 'auto'
        }

        currentMeter.style.flex = flex;
      })

      requestAnimationFrame(() => {
        innerMeters.forEach((meter) => {
          meter.style.width = '100%'
        })
      })
    }
  }
}
</script>
